import React, { Component } from "react"
import Grid from "@material-ui/core/Grid"
import CircularProgress from "@material-ui/core/CircularProgress"

export default function AuthenticateUser() {
  return function(Child) {
    return class extends Component {
      state = {
        userInfo: {},
        loading: true,
      }

      componentDidMount = async () => {
          this.setState({
            userInfo: {
              userName: "Guest",
              userId: null,
              userLevel: 0,
            },
            loading: false,
          })
      }

      render() {
        const { loading } = this.state

        if (loading) {
          return (
            <Grid container justify="center">
              <CircularProgress />
            </Grid>
          )
        }

        return <Child {...this.props} {...this.state} />
      }
    }
  }
}
